module.exports = __webpack_public_path__ + "img/newsletter-cake.5a02c77a.webp";